import { ref } from 'vue';
import { defineStore } from 'pinia';
import { useUserStore } from './user';

import dayjs, { Dayjs } from 'dayjs';
import { getUsers } from '@/utils/api';

import type { UserType, UsersIndexQuery } from '@/types/User.ts';

export const useUsersStore = defineStore('users', () => {
  const user = useUserStore();

  const usersData = ref<UserType[]>([]);
  const lastPage = ref(0);
  const lastUpdated = ref<Dayjs>();
  const loading = ref(false);

  const params = ref<UsersIndexQuery>({
    page: 1,
    results_per_page: 10,
    name: '',
    sortDesc: false,
    sortBy: 'name',
    archived: false,
  });

  function getData(override = false, ignoreLoad = false) {
    // Skip the load, used for when we simply update
    // the list behind the scenes
    if (!ignoreLoad) {
      loading.value = true;
    }

    // Use the Store Cache if we have it.
    if (override === false && usersData.value.length) {
      loading.value = false;
      return usersData.value;
    }

    // TODO: Don't pass empty Sort param or it'll throw a server error.
    if (params.value.sortBy === '') {
      delete params.value.sortBy;
    }
    if (params.value.account === null) {
      delete params.value.account;
    }

    getUsers(user.accessToken, params.value).then((resp) => {
      const { data, last_page } = resp;

      usersData.value = data;
      lastPage.value = last_page;
      lastUpdated.value = dayjs();
      loading.value = false;
    });
  }

  return {
    usersData,
    lastPage,
    params,
    loading,

    getData,
  };
});

// TODO:
// Auto-refetch by Last Updated time
